/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import { useThemeClassName } from '../../contexts/ThemeContext';

import styles from '../../../styles/blocks/prize.module.scss';

const propTypes = {
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
    image: AppPropTypes.image,
    category: PropTypes.string,
    badge: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
};

const defaultProps = {
    className: null,
    isContainer: false,
    containerClassName: null,
    image: null,
    category: null,
    badge: null,
    name: null,
    description: null,
};

const PrizeBlock = ({
    className,
    isContainer,
    containerClassName,
    image,
    category,
    badge,
    name,
    description,
}) => {
    const { url: imageUrl = null, alt: imageAlt } = image || {};
    const themeClassName = useThemeClassName(styles);
    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                <div className={styles.box}>
                    {category !== null ? <div className={styles.category}>{category}</div> : null}
                    {imageUrl !== null ? (
                        <div className={styles.imageContainer}>
                            <div className={styles.frame}>
                                <img className={styles.image} src={imageUrl} alt={imageAlt} />
                            </div>
                            {badge !== null ? (
                                <div className={styles.badge}>
                                    <div className={styles.circle}>
                                        <div
                                            className={styles.label}
                                            dangerouslySetInnerHTML={{ __html: badge }}
                                        />
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                    {name !== null || description !== null ? (
                        <div className={styles.body}>
                            {name !== null ? (
                                <h4 dangerouslySetInnerHTML={{ __html: name }} />
                            ) : null}
                            {description !== null ? (
                                <p dangerouslySetInnerHTML={{ __html: description }} />
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

PrizeBlock.propTypes = propTypes;
PrizeBlock.defaultProps = defaultProps;

export default PrizeBlock;
